t = require('views/internal/teacup-with-helpers')('crop_photo')

module.exports = ->
  t.img '.crop-image'
  t.button '.primary.js-done', ->
    t.format 'looks-good'
  t.button '.js-back', ->
    t.format 'try-again-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/crop_photo.coffee